import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, valuesAnalyze, changeViewForms, userByEmail, exportSelectAllEndpoints, exportSelectAllQueues, updateUser, readAllTenant, registerUser } from '../../../services';
import Loading from '../../../components/Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './UsersForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faSave, faArrowLeft, faUser, faShieldAlt, faList } from '@fortawesome/free-solid-svg-icons';
import validEmail from '../../../services/validEmail';

function UsersEdit() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit, toggleIsChangeFormElements } = getItensStateGlobal;

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [isRootVgs, setIsRootVgs] = useState(false);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [saving, setSaving] = useState(false);
  const [endpoints, setEndpoints] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tenants, setTenants] = useState([]);

  const [alert, setAlert] = useState({
    show: false,
    type: '',
    message: ''
  });

  const { changeBorderImputToRedOrNormal, changeVisibityMessages } = changeViewForms;

  const fetchUser = useCallback(async () => {
    try {
      if (!itemsSelectedToEdit) {
        return history.push('/config/usuarios/lista');
      }

      const emailToFetch = typeof itemsSelectedToEdit === 'string' 
        ? itemsSelectedToEdit 
        : itemsSelectedToEdit.email || itemsSelectedToEdit;

      if (!emailToFetch) {
        return history.push('/config/usuarios/lista');
      }

      const userFetched = await userByEmail({ email: emailToFetch });

      if (!userFetched || userFetched === 400 || typeof userFetched === 'number') {
        console.error('Erro ao buscar usuário:', userFetched);
        return history.push('/config/usuarios/lista');
      }

      const dataUser = await accessLocalStorage.getUserLocalStorage();
      if (!dataUser || !dataUser.user) {
        return history.push('/config/usuarios/lista');
      }

      const { user: { role, idtenant } } = dataUser;
      const isVgs = role === 'root' && idtenant === 'vgs';
      setIsRootVgs(isVgs);

      let fetchQueues = await exportSelectAllQueues();
      if (isVgs) {
        fetchQueues = fetchQueues || [];
      } else {
        fetchQueues = idtenant.includes('vgs') ? (fetchQueues || []) : (fetchQueues || []).filter((queue) => idtenant.includes(queue.accountcodequeue));
      }
      const itensQueues = fetchQueues.map((queue) => queue.namequeue || queue.queuesselect).filter(q => q);

      let fetchEndpoints = await exportSelectAllEndpoints();
      if (isVgs) {
        fetchEndpoints = fetchEndpoints || [];
      } else {
        fetchEndpoints = idtenant.includes('vgs') ? (fetchEndpoints || []) : (fetchEndpoints || []).filter((endpoint) => idtenant.includes(endpoint.tenant));
      }
      const itensEndpoints = fetchEndpoints.map((endpoint) => endpoint.endpoint).filter((e) => !isNaN(e));

      let fetchTenants = await readAllTenant();
      if (!isVgs && !idtenant.includes('vgs')) {
        fetchTenants = (fetchTenants || []).filter((tenant) => tenant.short_name === idtenant);
      }

      setEndpoints(itensEndpoints);
      setQueues(itensQueues);
      setTenants(fetchTenants || []);

      const endpointsViewerValue = userFetched.endpointsviewer;
      const queuesViewerValue = userFetched.queuesviewer;

      const processedEndpointsViewer = Array.isArray(endpointsViewerValue) 
        ? endpointsViewerValue 
        : (typeof endpointsViewerValue === 'string' && endpointsViewerValue.includes(','))
          ? endpointsViewerValue.split(',').map(e => e.trim()).filter(e => e)
          : endpointsViewerValue ? [endpointsViewerValue] : [];

      const processedQueuesViewer = Array.isArray(queuesViewerValue)
        ? queuesViewerValue
        : (typeof queuesViewerValue === 'string' && queuesViewerValue.includes(','))
          ? queuesViewerValue.split(',').map(e => e.trim()).filter(e => e)
          : queuesViewerValue ? [queuesViewerValue] : [];

      setValues({
        name: userFetched.name || '',
        email: userFetched.email || '',
        password: '',
        endpoint: userFetched.endpoint || '',
        role: userFetched.role || '',
        tenant: userFetched.idtenant || userFetched.tenant || '',
        idtenant: userFetched.idtenant || userFetched.tenant || '',
        tenants: isVgs ? [userFetched.idtenant || userFetched.tenant || ''] : [],
        endpointsviewer: processedEndpointsViewer,
        queuesviewer: processedQueuesViewer,
        active: userFetched.active !== undefined ? userFetched.active : true
      });

      setValidate({
        name: true,
        email: true,
        role: true,
        password: true,
        endpointsviewer: true,
        queuesviewer: true,
        tenant: true,
        tenants: true
      });
      setDisable(false);

      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar usuário:', error);
      setLoading(false);
      history.push('/config/usuarios/lista');
    }
  }, [itemsSelectedToEdit, history]);

  useEffect(() => {
    const loadUser = async () => {
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      if (!dataUser) {
        history.push('/');
        return;
      }
      if (dataUser && dataUser.user?.role !== 'root') {
        history.push('/home');
        return;
      }

      if (itemsSelectedToEdit) {
        await fetchUser();
      } else {
        history.push('/config/usuarios/lista');
      }
    };

    loadUser();
  }, [itemsSelectedToEdit, history, fetchUser]);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTextAndSpace, checkText } = valuesAnalyze;

    if (name === 'endpointsviewer') {
      if (value === 'all' || value === 'none') return true;
      if (Array.isArray(value)) {
        const allValid = value.every(v => v === 'all' || v === 'none' || checkNumber(v));
        changeScreen(allValid, name);
        return allValid;
      }
      let checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    }

    if (name === 'queuesviewer') {
      if (value === 'all' || value === 'none') return true;
      if (Array.isArray(value)) {
        return true;
      }
      const checkValueIsText = checkText(value);
      changeScreen(checkValueIsText, name);
      return checkValueIsText;
    }

    if (name === 'email') {
      const emailIsValid = validEmail(value);
      changeScreen(emailIsValid, name);
      return emailIsValid;
    }

    if (name === 'password') {
      if (!value || value === '') return true;
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if (name === 'role') {
      const checkValueIsText = checkText(value);
      changeScreen(checkValueIsText, name);
      return checkValueIsText;
    }

    if (name === 'name') {
      if (!value || value.trim() === '') {
        changeScreen(false, name);
        return false;
      }
      const trimmedValue = value.trim();
      if (trimmedValue.length < 2) {
        changeScreen(false, name);
        return false;
      }
      const checkValueIsCharacters = /^[a-zA-ZÀ-ÿ\s\.\-']{2,}$/.test(trimmedValue);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }

    if (name === 'tenant') {
      const tenantsId = tenants.map((tenant) => tenant.short_name);
      const checkRealTenant = tenantsId.includes(value);
      changeScreen(checkRealTenant, name);
      return checkRealTenant;
    }

    if (name === 'tenants') {
      if (!Array.isArray(value) || value.length === 0) {
        changeScreen(false, name);
        return false;
      }
      const tenantsId = tenants.map((tenant) => tenant.short_name);
      const allValid = value.every(v => tenantsId.includes(v));
      changeScreen(allValid, name);
      return allValid;
    }

    return true;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    let processedValue = value;
    if (name === 'endpointsviewer' || name === 'queuesviewer' || name === 'tenants') {
      processedValue = Array.from(item.selectedOptions, (option) => option.value);
    }

    const itemStatus = handleChangeDataAnalyze(name, processedValue);
    const newValidate = {
      ...validate,
      [name]: itemStatus === undefined ? true : itemStatus
    };

    setValidate(newValidate);

    const newValues = {
      ...values,
      [name]: processedValue
    };

    if (name === 'tenants' && isRootVgs && Array.isArray(processedValue) && processedValue.length > 0) {
      newValues.tenant = processedValue[0];
    }

    setValues(newValues);

    const requiredFields = ['name', 'email', 'role'];
    const allRequiredFilled = requiredFields.every(field => {
      const fieldValue = name === field ? processedValue : newValues[field];
      return fieldValue !== '' && fieldValue !== undefined && fieldValue !== null;
    });
    
    const allValid = Object.entries(newValidate).every(([key, val]) => {
      if (key === 'tenant' && !isRootVgs) return true;
      if (key === 'tenants' && !isRootVgs) return true;
      if (key === 'password' && (!processedValue || processedValue === '')) return true;
      return val === true;
    });
    
    setDisable(!(allValid && allRequiredFilled));
  };

  const endpointsViewerAnalyse = () => {
    if (values['endpointsviewer']) {
      if (values['endpointsviewer'].includes('all')) {
        values['endpointsviewer'] = ['all'];
      }
      if (values['endpointsviewer'].includes('none')) {
        values['endpointsviewer'] = ['none'];
      }
      if (values['endpointsviewer'].includes('all') && values['endpointsviewer'].includes('none')) {
        values['endpointsviewer'] = ['none'];
      }
    }
  };

  const queuesViewerAnalyse = () => {
    if (values['queuesviewer']) {
      if (values['queuesviewer'].includes('all')) {
        values['queuesviewer'] = ['all'];
      }
      if (values['queuesviewer'].includes('none')) {
        values['queuesviewer'] = ['none'];
      }
      if (values['queuesviewer'].includes('all') && values['queuesviewer'].includes('none')) {
        values['queuesviewer'] = ['none'];
      }
    }
  };

  const sendDataUsersGenerate = async () => {
    endpointsViewerAnalyse();
    queuesViewerAnalyse();

    setSaving(true);
    setAlert({ show: false, type: '', message: '' });

    try {
      if (isRootVgs && values.tenants && values.tenants.length > 0) {
        const tenantsToProcess = values.tenants;
        const originalTenant = values.idtenant || values.tenant;
        const firstTenant = tenantsToProcess[0];
        
        let updateSuccess = false;
        let createSuccessCount = 0;
        let createErrorCount = 0;
        const createErrors = [];

        const updateData = { ...values };
        updateData.tenant = firstTenant;
        delete updateData.tenants;
        delete updateData.idtenant;

        try {
          const result = await updateUser(updateData);
          if (result && Object.keys(result).length > 0) {
            updateSuccess = true;
          }
        } catch (error) {
          console.error('Erro ao atualizar usuário:', error);
        }

        if (tenantsToProcess.length > 1) {
          const tenantsToCreate = tenantsToProcess.slice(1);
          
          for (const tenant of tenantsToCreate) {
            try {
              const emailParts = values.email.split('@');
              const baseEmail = emailParts[0];
              const domain = emailParts[1] || 'example.com';
              const newEmail = `${baseEmail}+${tenant}@${domain}`;
              
              const userData = {
                name: values.name,
                email: newEmail,
                password: values.password || '',
                endpoint: values.endpoint || '',
                role: values.role,
                tenant: tenant,
                endpointsviewer: values.endpointsviewer || [],
                queuesviewer: values.queuesviewer || []
              };

              const response = await registerUser(userData);
              if (response && response.status === 201) {
                createSuccessCount++;
              } else {
                createErrorCount++;
                createErrors.push(tenant);
              }
            } catch (error) {
              createErrorCount++;
              createErrors.push(tenant);
              console.error(`Erro ao criar usuário para tenant ${tenant}:`, error);
            }
          }
        }

        if (updateSuccess || createSuccessCount > 0) {
          const messages = [];
          if (updateSuccess) messages.push('Usuário atualizado');
          if (createSuccessCount > 0) messages.push(`${createSuccessCount} usuário(s) criado(s)`);
          
          setAlert({
            show: true,
            type: createErrorCount === 0 ? 'success' : 'warning',
            message: `${messages.join(' e ')} com sucesso${createErrorCount > 0 ? `. ${createErrorCount} falha(s) para tenant(s): ${createErrors.join(', ')}` : ''}!`
          });
          
          window.scrollTo({ top: 0, behavior: 'smooth' });
          
          setTimeout(() => {
            history.push('/config/usuarios/lista');
          }, 3000);
        } else {
          setAlert({
            show: true,
            type: 'danger',
            message: `Não foi possível atualizar/criar usuários. Erros para tenant(s): ${createErrors.join(', ')}`
          });
          
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } else {
        const updateData = { ...values };
        if (isRootVgs && (updateData.idtenant || updateData.tenant)) {
          updateData.tenant = updateData.tenant || updateData.idtenant;
        }
        delete updateData.tenants;

        const result = await updateUser(updateData);
        
        if (result && Object.keys(result).length > 0) {
          setAlert({
            show: true,
            type: 'success',
            message: 'Usuário alterado com sucesso!'
          });
          
          window.scrollTo({ top: 0, behavior: 'smooth' });
          
          setTimeout(() => {
            history.push('/config/usuarios/lista');
          }, 2000);
        } else {
          setAlert({
            show: true,
            type: 'danger',
            message: 'Não foi possível alterar o usuário. Verifique os dados e tente novamente.'
          });
          
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      setAlert({
        show: true,
        type: 'danger',
        message: 'Erro ao atualizar usuário. Tente novamente.'
      });
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setSaving(false);
    }
  };

  const getDefaultSelectValue = (fieldName) => {
    if (!values[fieldName]) return '';
    if (Array.isArray(values[fieldName])) {
      return values[fieldName];
    }
    if (typeof values[fieldName] === 'string' && values[fieldName].includes(',')) {
      return values[fieldName].split(',').map(e => e.trim());
    }
    return [values[fieldName]];
  };

  if (loading) return <Loading />;

  return (
    <div className="users-form-container">
      <div className="users-form-header">
        <div className="users-form-title-wrapper">
          <svg className="users-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <div>
            <h1 className="users-form-title">Editar Usuário</h1>
            <p className="users-form-subtitle">{values.email || 'Carregando...'}</p>
          </div>
        </div>
        <Link to="/config/usuarios/lista" className="btn-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar
        </Link>
      </div>

      {alert.show && (
        <div className={`alert-message alert-${alert.type}`}>
          <div className="alert-header">
            <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
            <button className="alert-close" onClick={() => setAlert({ show: false, type: '', message: '' })}>
              ×
            </button>
          </div>
          <div className="alert-body">
            {alert.message}
          </div>
        </div>
      )}

      <form onSubmit={(e) => e.preventDefault()}>
        <div className="form-section-card">
          <h2 className="form-section-title">
            <FontAwesomeIcon icon={faUser} className="section-icon" />
            Informações Pessoais
          </h2>

          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">Nome do Usuário</label>
              <input
                className={`form-input ${validate.name === false ? 'is-danger' : ''}`}
                name="name"
                type="text"
                value={values.name || ''}
                onChange={(e) => {
                  setValues(prev => ({ ...prev, name: e.target.value }));
                  if (validate.name === false) {
                    handleChangeValues(e.target);
                  }
                }}
                onBlur={(e) => handleChangeValues(e.target)}
                placeholder="Nome completo"
              />
              {validate.name === false && (
                <p className="form-help is-danger">Caracteres inválidos! Use apenas letras, espaços, pontos, hífens e apóstrofos.</p>
              )}
            </div>

            <div className="form-field">
              <label className="form-label">E-mail</label>
              <input
                className={`form-input ${validate.email === false ? 'is-danger' : ''}`}
                name="email"
                type="email"
                value={values.email || ''}
                onChange={(e) => handleChangeValues(e.target)}
                placeholder="usuario@empresa.com.br"
                disabled
              />
              <p className="form-help">E-mail não pode ser alterado</p>
            </div>

            <div className="form-field">
              <label className="form-label">Senha</label>
              <input
                className={`form-input ${validate.password === false ? 'is-danger' : ''}`}
                name="password"
                type="password"
                onBlur={(e) => handleChangeValues(e.target)}
                placeholder="Deixe em branco para manter a senha atual"
              />
              {validate.password === false && (
                <p className="form-help is-danger">Verifique o tamanho e se existem caracteres inválidos!</p>
              )}
              <p className="form-help">Tamanho mínimo 6 caracteres. Deixe em branco para manter a senha atual.</p>
            </div>

            <div className="form-field">
              <label className="form-label">Ramal</label>
              <select
                className="form-select"
                name="endpoint"
                value={values.endpoint || ''}
                onChange={(e) => handleChangeValues(e.target)}
              >
                <option value="">Selecione um ramal</option>
                {endpoints.map((endpoint) => (
                  <option key={`endpoint-${endpoint}`} value={endpoint}>
                    {endpoint}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="form-section-card">
          <h2 className="form-section-title">
            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
            Permissões e Acesso
          </h2>

          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">Tipo de Usuário</label>
              <select
                className={`form-select ${validate.role === false ? 'is-danger' : ''}`}
                name="role"
                value={values.role || ''}
                onChange={(e) => handleChangeValues(e.target)}
              >
                <option value="">Selecione</option>
                <option value="user">Básico</option>
                <option value="admin">Administrativo</option>
              </select>
              {validate.role === false && (
                <p className="form-help is-danger">Tipo de usuário inválido!</p>
              )}
            </div>

            {isRootVgs && (
              <div className="form-field">
                <label className="form-label">Cliente(s)</label>
                <select
                  className={`form-select ${validate.tenants === false ? 'is-danger' : ''}`}
                  name="tenants"
                  multiple
                  size={Math.min(tenants.length, 5)}
                  value={values.tenants || [values.idtenant || values.tenant || '']}
                  onChange={(e) => handleChangeValues(e.target)}
                >
                  {tenants.map((tenant) => (
                    <option key={`tenant-${tenant.short_name}`} value={tenant.short_name}>
                      {tenant.name} ({tenant.short_name})
                    </option>
                  ))}
                </select>
                {validate.tenants === false && (
                  <p className="form-help is-danger">Selecione pelo menos um cliente válido!</p>
                )}
                <p className="form-help">Selecione múltiplos clientes (Ctrl+Clique). O primeiro será usado para atualizar este usuário, os demais criarão novos usuários com emails únicos (base+tenant@dominio).</p>
              </div>
            )}
          </div>
        </div>

        <div className="form-section-card">
          <h2 className="form-section-title">
            <FontAwesomeIcon icon={faList} className="section-icon" />
            Visibilidade de Recursos
          </h2>

          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">Exibir Ramais</label>
              <select
                className={`form-select form-select-multiple ${validate.endpointsviewer === false ? 'is-danger' : ''}`}
                name="endpointsviewer"
                multiple
                value={getDefaultSelectValue('endpointsviewer')}
                onChange={(e) => handleChangeValues(e.target)}
              >
                <option value="all">Todos</option>
                <option value="none">Nenhum</option>
                {endpoints.map((endpoint) => (
                  <option key={`ep-${endpoint}`} value={endpoint}>
                    {endpoint}
                  </option>
                ))}
              </select>
              {validate.endpointsviewer === false && (
                <p className="form-help is-danger">Caracteres inválidos!</p>
              )}
              <p className="form-help">Mantenha Ctrl pressionado para selecionar múltiplos itens</p>
            </div>

            <div className="form-field">
              <label className="form-label">Exibir Filas</label>
              <select
                className={`form-select form-select-multiple ${validate.queuesviewer === false ? 'is-danger' : ''}`}
                name="queuesviewer"
                multiple
                value={getDefaultSelectValue('queuesviewer')}
                onChange={(e) => handleChangeValues(e.target)}
              >
                <option value="all">Todas</option>
                <option value="none">Nenhuma</option>
                {queues.map((queue) => (
                  <option key={`q-${queue}`} value={queue}>
                    {queue}
                  </option>
                ))}
              </select>
              {validate.queuesviewer === false && (
                <p className="form-help is-danger">Caracteres inválidos!</p>
              )}
              <p className="form-help">Mantenha Ctrl pressionado para selecionar múltiplos itens</p>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <Link to="/config/usuarios/lista" className="btn-cancel">
            <FontAwesomeIcon icon={faArrowLeft} />
            Cancelar
          </Link>
          <button
            className="btn-submit"
            type="submit"
            onClick={sendDataUsersGenerate}
            disabled={disable || saving}
          >
            <FontAwesomeIcon icon={faSave} />
            {saving ? 'Salvando...' : 'Salvar Alterações'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default UsersEdit;

